import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScaleContain implements IScrollViewScale {

    constructor(public maxScale: number = Number.MAX_VALUE) {

    }

    public getScale(view: ScrollView): number {
        var scX = view.width / view.contentWidth;
        var scY = view.height / view.contentHeight;
        return Math.min(scX, scY, this.maxScale);
    }
}